import { EMPTY, ERROR } from "constants/Status";

interface ReloadUpcomingPaymentWithStateArgs {
  clientId: string;
  realm: string;
  loadUpcomingPayment: (clientId: string, realm: string) => Promise<unknown>;
  setLoadingStatus: (isLoading: boolean) => void;
  setConfirmCancelModalOpen: (isOpen: boolean) => void;
  setCancelState: (state: string) => void;
  setCancelErrorMessage: (message: string | undefined) => void;
}

export const reloadUpcomingPaymentWithState = async ({
  clientId,
  realm,
  loadUpcomingPayment,
  setLoadingStatus,
  setConfirmCancelModalOpen,
  setCancelState,
  setCancelErrorMessage,
}: ReloadUpcomingPaymentWithStateArgs): Promise<void> => {
  setLoadingStatus(true);
  setConfirmCancelModalOpen(false);
  setCancelState(EMPTY);
  setCancelErrorMessage(undefined);

  try {
    await loadUpcomingPayment(clientId, realm);
  } catch (error: any) {
    setCancelState(ERROR);
    setCancelErrorMessage(error.message);
  } finally {
    setLoadingStatus(false);
  }
};
